<h2 mat-dialog-title>Export to Excel</h2>
<mat-dialog-content>
  <form [formGroup]="exportUserForm">
    <mat-radio-group formControlName="exportAll" class="radio-group" matInput>
      <mat-radio-button value="all">All Users</mat-radio-button>
      <mat-radio-button value="filter">Searched Users</mat-radio-button>
      <mat-radio-button value="one">{{selectedUser.userName}}</mat-radio-button>
    </mat-radio-group>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button id="exportUsers" color="primary" (click)="export()">Export</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
